import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=570bb0f1&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570bb0f1')) {
      api.createRecord('570bb0f1', component.options)
    } else {
      api.reload('570bb0f1', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=570bb0f1&", function () {
      api.rerender('570bb0f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gdP56BNGYwNU/JS/pricehelp.vue"
export default component.exports